import React, { useEffect, useState } from "react";

const CountdownProgressBar = ({ height, onProgressComplete, color, appliedOfferDetail }) => {
  const duration = 3000; // total duration in ms
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const startTime = Date.now();

    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, duration - elapsed);
      const percentage = (remaining / duration) * 100;
      if (percentage == 0) {
        onProgressComplete(true)
      }
      setProgress(percentage);

      if (remaining === 0) {
        clearInterval(interval);
      }
    }, 1); // Update every millisecond

    return () => clearInterval(interval); // Cleanup on unmount
  }, [appliedOfferDetail]);

  return (
    <div style={{ width: "100%", height: height || "30px", backgroundColor: "#eee", borderRadius: "8px", overflow: "hidden" }}>
      <div
        style={{
          height: "100%",
          width: `${progress}%`,
          backgroundColor: color || "#1890FF",
          transition: "width 0s",

        }}
      />
    </div>
  );
};

export default CountdownProgressBar;
